import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/simulate'

const simulateData = new ApiCore({
	create: true,
	url: url
})

simulateData.simulate = (id, payload, action) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${action}/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

export default simulateData
